import { useMemo } from "react";
import { api } from "~/api/client";
import { useAuth } from "~/contexts/auth-context";

export function useApi() {
  const { authToken } = useAuth();

  return useMemo(() => {
    api.setAuthToken(authToken);

    return api;
  }, [authToken]);
}
